import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Paper,
  IconButton,
  Box,
  Button,
  TextField,
  InputAdornment,
  CircularProgress
} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import Navbar from "../../../../globals/components/Navbar";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../../../globals/utils/api";
import TablePaginationActions from "../../../../globals/components/TablePaginationActions";

function UserList() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true); // State for loading indicator
  const navigate = useNavigate();

  // Fetch users from the API
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true); // Start loading
        const response = await apiClient("/internal-user", "GET");
        setUsers(response.data);
      } catch (error) {
        console.error("Failed to fetch users:", error);
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchUsers();
  }, []);

  // Filter users based on the search query (search only on full_name)
  const filteredUsers = users.filter(user =>
    (user.full_name || "").toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination controls
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Calculate current rows based on pagination and filtering
  const currentRows = filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <Navbar />

      <Box sx={{ maxWidth: "100%", padding: "20px" }}>
        {/* Heading */}
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
          Internal Users
        </Typography>

        {/* Search bar and New User Button */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <TextField
            label="Search by Full Name"
            variant="outlined"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{
              width: '300px',
              borderRadius: '8px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => {navigate('/new_internal_user')}}
          >
            New User
          </Button>
        </Box>

        {/* Loader or Table */}
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
            <CircularProgress />
          </Box>
        ) : (
          <>
            <TableContainer component={Paper} sx={{ width: "100%", overflowX: "auto", mb: 2 }}>
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: "#f0f0f0" }}>
                    <TableCell>Full Name</TableCell>
                    {/* <TableCell align="right">Username</TableCell> */}
                    <TableCell align="right">Email</TableCell>
                    <TableCell align="right">Permission Level</TableCell>
                    {/* <TableCell align="center">Active</TableCell> */}
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentRows.map((user) => (
                    <TableRow key={user.internal_user_id}>
                      <TableCell>{user.full_name || "N/A"}</TableCell>
                      {/* <TableCell align="right">{user.user.username}</TableCell> */}
                      <TableCell align="right">{user.user.email}</TableCell>
                      <TableCell align="right">{user.is_admin ? "Admin" : "User"}</TableCell>
                      {/* <TableCell align="center">
                        <Switch
                          checked={user.is_admin !== null ? user.is_admin : false}
                          color="primary"
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      </TableCell> */}
                      <TableCell align="center">
                        <IconButton
                          color="primary"
                          onClick={() => {navigate(`/edit_internal_user/${user.internal_user_id}`)}}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
          ActionsComponent={TablePaginationActions}
              component="div"
              count={filteredUsers.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </>
        )}
      </Box>
    </>
  );
}

export default UserList;
